// extracted by mini-css-extract-plugin
module.exports = {"container":"_1mJK8caWu1HjW1e6j6eTpm","card":"Zu0XX6jA4APJ3OV_egCxx","icon":"Fjn9HyLWLKcazVTTa5qcY","preLoaderShimmer":"_3m-UtvOl2n6uRguNfwx1AQ"};